import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import groups from './submodules/groups';
import { canonicalUserLanguage } from '@/utils/language';

const state = {
    user: null,
    user_groups: [],
    user_loading: false,
    user_deleting: false,
    user_saving: false,
    user_saving_errors: {},
};

const mutations = {
    updateUser(state, user) {
        state.user = {
            ...user,
            language: canonicalUserLanguage(user?.language),
        };
    },

    updateUserLoading(state, loading) {
        state.user_loading = loading;
    },

    updateUserLoadingErrors(state, errors) {
        state.user_loading_errors = errors;
    },

    updateUserSaving(state, saving) {
        state.user_saving = saving;
    },

    updateUserSavingErrors(state, errors) {
        state.user_saving_errors = errors || {};
    },


    updateUserDeleting(state, deleting) {
        state.user_deleting = deleting;
    },

    updateUserGroups(state, groups) {
        state.user_groups = groups;
    },
};

const actions = {
    async init({ commit, dispatch, state }, params) {
        let filters = {};
        if (params.user.entity) {
            filters.for_entity = params.user.entity;
        } else {
            filters.myentity = true;
        }

        commit('updateUser', params.user);
        commit('updateUserGroups', params.user?.groups || []);
        dispatch('groups/init', { filters });
        const response = await dispatch('groups/fetchGroups');
        if (response.data.results.length == 1) {
            commit('updateUserGroups', [response.data.results[0].id]);
        }
    },

    async fetchUser({ commit, dispatch, state }, params) {
        commit('updateUserLoadingErrors', null);
        commit('updateUserLoading', true);
        try {
            const response = await axios.get(`/api/users/${params.user_id}/`);
            commit('updateUserLoading', false);
            commit('updateUser', response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateUserLoading', false);
            commit('updateUserLoadingErrors', error.details);
            throw error;
        }
    },

    async saveUser({ commit, dispatch, state, rootGetters }, params) {
        commit('updateUserSaving', true);

        let url = '/api/users/';
        let method = axios.post;

        if (state.user.id) {
            url = `/api/users/${state.user.id}/`;
            method = axios.put;
        }
        let payload = Object.assign({}, state.user, { groups: state.user_groups });
        payload.language = canonicalUserLanguage(payload.language);
        if (!rootGetters['session/current_user_is_owner']) {
            delete payload.is_owner;
        }
        try {
            const response = await method(url, payload);
            return response;
        } catch (xhr_error) {
            let errors = utils.handleError(xhr_error);
            commit('updateUserSavingErrors', errors.details);
            throw errors;
        } finally {
            commit('updateUserSaving', false);
        }
    },

    async deleteUser({ commit, dispatch, state }, params) {
        commit('updateUserDeleting', true);
        try {
            const response = await axios.delete(`/api/users/${params.instance.id}/`);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit('updateUserDeleting', false);
        }
    },

    async recoverPassword({ commit, dispatch, state }, params) {
        try {
            const response = await axios.post("/api/account/recover/", { email: params.instance.email });
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    },

    async deactivate({ commit, dispatch, state }, params) {
        commit('updateUserSaving', true);

        let url = `/api/users/${params.instance.id}/deactivate/`;
        let method = axios.post;

        try {
            const response = await method(url);
            commit('updateUserSaving', false);
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateUserSavingErrors', error.details);
            commit('updateUserSaving', false);
            throw error;
        }
    },

    async activate({ commit, dispatch, state }, params) {
        commit('updateUserSaving', true);

        let url = `/api/users/${params.instance.id}/activate/`;
        let method = axios.post;

        try {
            const response = await method(url);
            commit('updateUserSaving', false);
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateUserSavingErrors', error.details);
            commit('updateUserSaving', false);
            throw error;
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        groups: groups(),
    }
};




